import { Component } from '@angular/core';
import { ReportesService } from '../reportes.service';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-reports-index',
  templateUrl: './reports-index.component.html',
  styleUrls: ['./reports-index.component.css']
})
export class ReportsIndexComponent {

  TipoUsuario = TipoUsuario;

  constructor( private reportesServices : ReportesService, private authService: AuthService ) {
  }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }
}
